var Dstqs;

(function($){

    Dstqs = {

        $items : null,
        window : null,

        init : function(){
            
            this.window = $( window );

            $items = $( 'section.destaque' );
            if( !$items.length ) return;
            for( var dts=0; dts<$items.length; dts++ ){
                this.configure( $items.eq( dts ) );
            }

        },

        configure : function( $el ){

            var data = $el.data( 'Dstqs' );
            if( data !== undefined ) return data;

            data = {
                $ : $el,
                _ : $el.get( 0 ),
                $firula : $el.find( 'span.firula > span' ),
                timeout : false
            }
            if( $el.hasClass( 'type4' ) ){
                data.type = 4;
            }
            $el.data( 'Dstqs', data );

            if( data.type === 4 ){
                this.bindSpinCircle( data );
            }

        },

        bindSpinCircle : function( data ){

            this.window.scroll(function(){
                Dstqs.checkScroll( data );
            });
            Dstqs.checkScroll( data );
            
        },

        checkScroll : function( data ){

            var 
                scrollTop = this.window.scrollTop(),
                limitRotate = ( Math.ceil( data.$firula.offset().top ) + Math.ceil( data.$firula.outerHeight(true) ) ) * 1.2
            ;   

            if( scrollTop <= limitRotate ){
                var angle = Math.round( scrollTop * 100 / 360 );
                data.$firula.css( 'transform', 'rotate('+ angle +'deg)' );
            }
        
        }

    }
    $(function(){
        Dstqs.init();
    })

})(jQuery);